export default [
  {
    width: '40px',
    value: 'edit',
    align: 'center',
    colModifiers:[
      { type: 'edit' }
    ],
    editPath: 'districts/edit/'
  },
  { text: 'Название', value: 'name' }
]
